/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Badge_ExperienceInputs */

const et_hero_badge_experience = /** @type {(inputs: Hero_Badge_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4+ aastat kogemust`)
};

const en_hero_badge_experience = /** @type {(inputs: Hero_Badge_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4+ years of experience`)
};

/**
* | output |
* | --- |
* | "4+ years of experience" |
*
* @param {Hero_Badge_ExperienceInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_badge_experience = /** @type {((inputs?: Hero_Badge_ExperienceInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Badge_ExperienceInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_hero_badge_experience(inputs)
	return en_hero_badge_experience(inputs)
});